
import { useState, useEffect } from "react";
import { parseISO } from "date-fns";

interface TimeRemainingProps {
  endTime: string;
}

export const TimeRemaining = ({ endTime }: TimeRemainingProps) => {
  const [timeLeft, setTimeLeft] = useState<string>("");

  useEffect(() => {
    const updateTimeLeft = () => {
      // Parse the ISO string without timezone adjustment
      const endTimeDate = parseISO(endTime);
      const now = new Date();
      
      // Calculate time difference using the timestamps
      const diff = endTimeDate.getTime() - now.getTime();

      if (diff > 0) {
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        setTimeLeft(`${hours}h ${minutes}m`);
      } else {
        setTimeLeft("Expired");
      }
    };

    updateTimeLeft();
    const interval = setInterval(updateTimeLeft, 60000);
    return () => clearInterval(interval);
  }, [endTime]);

  return (
    <p className="text-sm font-medium">
      Time Left: <span className={`${
        timeLeft === "Expired" ? "text-red-600" : "text-green-600"
      }`}>{timeLeft}</span>
    </p>
  );
};
